export const pageTitle = (title) => {
  return ( document.title = "PICS LENS | " + title );
}